import { render, staticRenderFns } from "./OfacControl.vue?vue&type=template&id=2c55fffe&scoped=true"
import script from "./OfacControl.vue?vue&type=script&lang=js"
export * from "./OfacControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55fffe",
  null
  
)

export default component.exports